export default __webpack_public_path__ + "static/media/o_processo_adaptativo_de_aprender_a_ler.51dc1bd6.png";